import { useMutation } from '@tanstack/react-query';
import { OrganizationDto, UpdateOrganizationDiscountDto } from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

export const useUpdateOrganizationDiscount = (organizationId: string, onSuccess: () => void) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateOrganizationDiscount', organizationId],
        mutationFn: (body: UpdateOrganizationDiscountDto) => apiClient.fetchApi<OrganizationDto, UpdateOrganizationDiscountDto>({ method: 'POST', endpoint: `organizations/${organizationId}/discount`, body }),
        onSuccess: (data) => {
            onSuccess();
            if (data.id === selectedOrganization?.id) {
                setSelectedOrganization(data);
            }
        },
    });
};
